import { createSelector } from "reselect"
import { values } from "lodash"

import { selectChannels } from "selectors/references"
import { selectSections } from "selectors/section"

const selectGenre = state => state.genres

export default createSelector([selectGenre, selectChannels], (genre, channels) => {
  if (genre.error) {
    return {
      error: genre.error,
    }
  }

  if (genre.pending || !genre.items) {
    return { pending: true }
  }

  // const mappedGenres = genre.items.map(tile => {
  // if (tile.title_formatter) {
  //   tile.title = FormatterHelper.styledFormatter(tile.title_formatter)
  // }
  //
  // const channelId = get(tile, "type") === consts.tileType.channel ? tile.id : get(tile, "video.channel_id")
  // const channel = channels.find(c => c.getId() === channelId)

  //   return new Program({ ...tile })
  // })

  const sections = selectSections(values([genre]), { channels })

  return {
    ...genre,
    getSections() {
      return sections
    },
  }
})
